<template>
    <v-layout row wrap class="privacy-settings">
        <v-flex tag="h2">
            {{privacySettingsConstants.PRIVACY_SETTINGS}}
        </v-flex>
        <v-flex xs12 class="white_background">
            <v-tabs color=ypo_blue dark slider-color="ypo_gold" v-model="activeTab">
                <v-tab key="emailSettings" to="emailSettings" data-qe-id="privacySettings_emailsTab">{{privacySettingsConstants.EMAILS}}</v-tab>
                <v-tab key="notification" to="notification" data-qe-id="privacySettings_notificationsTab">{{privacySettingsConstants.NOTIFICATIONS}}</v-tab>
                <!-- TODO: Will Uncomment post MVP -->
                <!-- <v-tab :key="visibility" to="visibility" data-qe-id="privacySettings_myVisibilityTab">{{privacySettingsConstants.MY_VISIBILITY}}</v-tab> -->
                <v-tabs-items touchless class="privacy-settings__tab__container">
                <v-tab-item key="emailSettings" value="emailSettings">
                  <router-view data-qe-id="privacySettings_emailSettings-route" class="mt-4" v-if="activeTab === 'emailSettings'" />
                </v-tab-item>
                <v-tab-item value="notification" key="notification">
                  <router-view data-qe-id="privacySettings_notifications-route" v-if="activeTab === 'notification'" />
                </v-tab-item>
                <!-- <v-tab-item value="visibility" :key="visibility">
                  <router-view  class="mt-4" v-if="activeTab === 'visibility'" />
                </v-tab-item> -->
                </v-tabs-items>
            </v-tabs>
        </v-flex>
    </v-layout>
</template>

<script>
  import { privacySettingsConstants } from "../MyAccount/privacysettings.constants";

  export default {
    name: "PrivacySettings",
    data: () => ({
      privacySettingsConstants,
      activeTab: 'emailSettings',
    }),
  };
</script>

<style lang="scss" scoped>
  @import "../../common/styles/_colors.scss";

  h2 {
    background: $ypo_blue;
    color: $white;
    padding: 40px 0 50px 20px;
    font-size: 30px;
    font-weight: 500;
    margin-top: 64px;
    border-top: 1px solid rgba($white, 0.08);
  }

  .theme--dark.v-tabs__bar .v-tabs__div {
    text-transform: capitalize;
    margin-left: 15px;
  }
  @media (max-width: 767px) {
    .privacy-settings {
      & h2{
        margin-top: 56px;
        padding: 15px 0 15px 20px;
        font-size: 20px;
        border-top: 1px solid $ypo-dark-gray;
      }
    }
  }
</style>

<style lang="scss">

.privacy-settings__tab__container .v-window__container--is-active {
  overflow: inherit;
  height: auto !important;
}

</style>
